import { render, staticRenderFns } from "./AppStoreReplyReview.vue?vue&type=template&id=6344fa0c&scoped=true"
import script from "./AppStoreReplyReview.vue?vue&type=script&lang=js"
export * from "./AppStoreReplyReview.vue?vue&type=script&lang=js"
import style0 from "./AppStoreReplyReview.vue?vue&type=style&index=0&id=6344fa0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6344fa0c",
  null
  
)

export default component.exports